import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as SubjectIcon } from "../../../images/subjectimage/subjecticon.svg";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import useStyles from "../../../../styles";
import ViewAllocatedCenter from "./ViewAllocatedCenterForm";


function AllocatedCenter() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon:<SubjectIcon />,
      mainheading: "Center",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext:"New Center",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path:"/admin/addallocatedcenter",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading}/>
      <ViewAllocatedCenter/>
    </div>
  );
}
export default AllocatedCenter;